import React from 'react';
import { Link } from 'react-router-dom';

export default function MaintenancePage() {
  return (
    <div style={{ minHeight: '70vh', display: 'grid', placeItems: 'center', padding: 24 }}>
      <div style={{ maxWidth: 640, width: '100%', textAlign: 'center' }}>
        <h1 style={{ fontSize: 28, fontWeight: 800, marginBottom: 12 }}>Sistema en mantenimiento</h1>
        <p style={{ opacity: 0.9, marginBottom: 18 }}>
          Por el momento el portal de clientes no está disponible. Intenta nuevamente más tarde.
        </p>
        <div style={{ display: 'inline-flex', gap: 10, justifyContent: 'center' }}>
          <Link
            to="/"
            style={{
              padding: '10px 14px',
              borderRadius: 10,
              border: '1px solid rgba(255,255,255,0.18)',
              textDecoration: 'none'
            }}
          >
            Ir al inicio
          </Link>
          <Link
            to="/login"
            style={{
              padding: '10px 14px',
              borderRadius: 10,
              border: '1px solid rgba(255,255,255,0.18)',
              textDecoration: 'none'
            }}
          >
            Iniciar sesión
          </Link>
        </div>
      </div>
    </div>
  );
}
